import { iconNames } from '@zapier/design-system';

export type Align = 'center' | 'left' | 'right';

export enum ContentStyle {
  paragraph1 = 'paragraph1',
  paragraph1Bold = 'paragraph1Bold',
  paragraph1Short = 'paragraph1Short',
  paragraph1ShortBold = 'paragraph1ShortBold',
  paragraph3 = 'paragraph3',
  paragraph3Bold = 'paragraph3Bold',
}
export type ContentStyleType = keyof typeof ContentStyle;

export enum CtaStyle {
  primary = 'primary',
  'primary-alt' = 'primary-alt',
  secondary = 'secondary',
  tertiary = 'tertiary',
}
export type CtaStyleType = keyof typeof CtaStyle;

export enum TextPlacement {
  left = 'left',
  right = 'right',
}
export type TextPlacementType = keyof typeof TextPlacement;

export enum MobileTextPlacement {
  top = 'top',
  bottom = 'bottom',
}
export type MobileTextPlacementType = keyof typeof MobileTextPlacement;

export enum HeadingStyle {
  pageHeader3 = 'pageHeader3',
  pageHeader5 = 'pageHeader5',
  sectionHeader3 = 'sectionHeader3',
  paragraph1Bold = 'paragraph1Bold',
}
export type HeadingStyleType = keyof typeof HeadingStyle;

export enum CTASectionVariant {
  standard = 'standard',
  filled = 'filled',
  centered = 'centered',
}

export type CTASectionVariantType = keyof typeof CTASectionVariant;

export { iconNames };

export enum HeroVariant {
  standard = 'Standard',
  colorBlock = 'Color Block',
  features = 'Features',
}

export type HeroVariantType = keyof typeof HeroVariant;
